import { configureStore } from "@reduxjs/toolkit";
import SideDisplaySlice from "./../Redux/SideDisplaySlice";
import Accounts from "./Accounts";
import profileDataReducer from "./ProfileDataSlice";
import incomeDataReducer from "./IncomeWallet";
import teamDataReducer from "./TeamSlice";
import Accountsview  from "./viewAccount";
import windowStatusReducer from "./WindowStatusSlice";
import refreshReducer from "./RefreshSlice";
export default configureStore({
  reducer: {
    sideDisplay: SideDisplaySlice,
    account: Accounts,
    accountview: Accountsview,
    profileData: profileDataReducer,
    incomeData: incomeDataReducer,
    teamData: teamDataReducer,
    windowStatus: windowStatusReducer,
    refresh: refreshReducer,
  },
});
